'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ./~/@xdbchain/js-stellar-sdk/~/axios/lib/cancel/isCancel.js
// module id = 235
// module chunks = 0